import { axios } from '@/utils/request'

const api = {
  queue: '/queue',
  companies: '/company',
  meters: '/meter',
  batch: '/batch',
  start: '/queue/start',
  complete: '/queue/complete',
  cancel: '/queue/cancel',
  count: '/queue/count',
  save: '/queue/save',
  meter_detail: '/meter/detail',
  meter_volumetric: '/meter/volumetric'
}

export default api

export function getQueue (page) {
  return axios({
    url: api.queue,
    method: 'get',
    params: { page: page }
  })
}

export function getCompanies (search) {
  return axios({
    url: api.companies,
    method: 'get',
    params: { search: search }
  })
}

export function getMeters (companyid, search) {
  return axios({
    url: api.meters,
    method: 'get',
    params: { companyID: companyid, filter: search }
  })
}

export function getBatchDetail (batch) {
  return axios({
    url: api.batch,
    method: 'get',
    params: { batch: batch }
  })
}

export function saveQueueItem (item) {
  return axios({
    url: api.save,
    method: 'post',
    data: item
  })
}

export function start (id) {
  return axios({
    url: api.start,
    method: 'post',
    params: { id: id }
  })
}

export function cancel (id) {
  return axios({
    url: api.cancel,
    method: 'post',
    params: { id: id }
  })
}

export function count () {
  return axios({
    url: api.count,
    method: 'get'
  })
}

export function getMeterDetail (meterID) {
  return axios({
    url: api.meter_detail,
    method: 'get',
    params: { meterID: meterID }
  })
}

export function getMeterVolumetric (meterID) {
  return axios({
    url: api.meter_volumetric,
    method: 'get',
    params: { meterID: meterID }
  })
}
